export function isRequired(fieldName: string) {
	return `${fieldName} is required`;
}
